import { createFileRoute } from "@tanstack/react-router";

import { BASE_COLOR } from "~/components/feature/balance/components/BalanceLongTermLiabilities";
import { DetailPage } from "~/components/feature/shared/components/DetailPage";

export const Route = createFileRoute(
  "/_app/dashboard/balance/long-term-liabilities/$category/detail",
)({
  component: RouteComponent,
});

function RouteComponent() {
  const { category } = Route.useParams();

  return (
    <DetailPage
      tab="long-term-liabilities"
      category={category}
      targetMetric="balance"
      baseColor={BASE_COLOR}
    />
  );
}
